<template>
  <count-badge :count="count"/>
</template>

<script lang="ts">
import EventBus from '@/misc/event-bus'
import type { CustomWindow } from '@/misc/custom-window'
import { HttpGet } from '@/services/Service'
import CountBadge from '@/global/CountBadge.vue'
import { isLicensedTo } from '@/general'

declare let window: CustomWindow

export default {
  name: 'OrderCountBadge',

  components: {
    CountBadge
  },

  props: {
    initialCount: {
      type: Number,
      default: 0
    },

    fetchCount: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      count: this.initialCount
    }
  },

  created () {
    if (isLicensedTo('orders')) {
      this.startListeningForEvents()

      EventBus.$on?.('websocket-reconnected', () => this.updateCount())
    }

    if (this.fetchCount) this.updateCount()
  },

  methods: {
    async updateCount () {
      const params = {
        status: 'submitted'
      }

      return await HttpGet('/api/v1/orders/status', { params })
        .then((response) => (this.count = response.data.count))
        .catch(console.error)
    },

    async startListeningForEvents () {
      if (!window.settings.current_tenant || !window.Echo) return

      window.Echo
        .channel(`order_${window.settings.current_tenant}`)
        .listen('OrderCountChange', (e: { count: number }) => (this.count = e.count))
    }
  }
}
</script>
